// extracted by mini-css-extract-plugin
export default {"container":"LocationCard_container__vwVzc","heading":"LocationCard_heading__50OXK","address":"LocationCard_address__RHIvV"};